import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function CommonDatePicker({
  FinalDate,
  handleDateChange,
  showDefaultDate = true,
  disabled = false
}) {
  // Fri Aug 16 2024 17:00:00 GMT-0700 (Pacific Daylight Time)
  const [selectedDate, setSelectedDate] = useState(
    moment().tz("America/New_York").toDate()
  );
  useEffect(() => {
    const getDate = moment(FinalDate).tz("America/New_York").toDate();
    console.log(FinalDate, "getDate");
    console.log(getDate, "getDate");
    setSelectedDate(getDate);
  }, [FinalDate]);

  const onDateChange = (date) => {
    console.log(date, "chnageDateCheck");
    if (date) {
      setSelectedDate(date);
      const formattedDate = moment(date).format("YYYY-MM-DD");
      handleDateChange(formattedDate);
    }
  };

  console.log(showDefaultDate, "showDefaultDate");
  console.log(disabled, "disabledinput");

  return (
    <div>
      <DatePicker
        selected={showDefaultDate ? selectedDate : null}
        onChange={onDateChange}
        dateFormat="MM/dd/yyyy"
        placeholderText="Choose Date"
        className="form-control form-control-sm datetimepicker"
        disabled={disabled}
      />
    </div>
  );
}

export default CommonDatePicker;
